import { render, staticRenderFns } from "./UserAddress0.vue?vue&type=template&id=78bbc932&"
import script from "./UserAddress0.vue?vue&type=script&lang=js&"
export * from "./UserAddress0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports